import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
export function getTimeInSeconds(time) {
  var _time$split = time.split(':'),
    _time$split2 = _slicedToArray(_time$split, 3),
    hourStr = _time$split2[0],
    minuteStr = _time$split2[1],
    _time$split2$ = _time$split2[2],
    secondStr = _time$split2$ === void 0 ? '0' : _time$split2$;
  var hours = Number(hourStr);
  var minutes = Number(minuteStr);
  var seconds = Number(secondStr);
  if (Number.isNaN(hours) || Number.isNaN(minutes) || Number.isNaN(seconds)) {
    return null;
  }
  return hours * 3600 + minutes * 60 + seconds;
}